var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkMiddleShelf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 21,
    viewBox: "0 0 180 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shelf_1",
    x: 0,
    y: 0,
    width: 180,
    height: 8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shelf_1-2",
    x: 0,
    y: 8,
    width: 180,
    height: 13,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102,
    result: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141413"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:url(#linear-gradient)}.cls-2{fill:#fff}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_750",
    "data-name": "Group 750"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup",
    transform: "translate(-279 -776)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shelf_1-3",
    "data-name": "shelf 1",
    className: "cls-1",
    transform: "translate(279 776)",
    d: "M0 0h180v8H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(279 776)",
    style: {
      filter: "url(#shelf_1)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "shelf_1-4",
    "data-name": "shelf 1",
    className: "cls-2",
    d: "M0 0h180v8H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup",
    transform: "translate(-279 -776)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "shelf_1-5",
    "data-name": "shelf 1",
    className: "cls-1",
    transform: "translate(279 784)",
    d: "M0 0h180v13H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(279 776)",
    style: {
      filter: "url(#shelf_1-2)"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "shelf_1-6",
    "data-name": "shelf 1",
    className: "cls-2",
    transform: "translate(0 8)",
    d: "M0 0h180v13H0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMiddleShelf);
export default __webpack_public_path__ + "static/media/darkMiddleShelf.14fbc14ba4e63f638a5e5482aeb83e87.svg";
export { ForwardRef as ReactComponent };